import { View } from "react-native";
import { Button } from "~/components/Button";
import { BaseText, Title } from "~/components/layout/text";
import { QendoIcon } from "~/components/QendoIcon";
import { Gap, Items, Padding, Width } from "~/constants/layout";
import { useTheme } from "~/providers/ThemeProvider";

export type LoadingErrorProps = {
    retry?: () => unknown;
};

export const LoadingError = ({ retry }: LoadingErrorProps) => {
    const { colours } = useTheme();
    return (
        <View style={[Items.center, Width.full, Gap.sm, Padding.horizontal_lg, Padding.vertical_12]}>
            <QendoIcon size={38} color={colours.icon.danger} name="warning-outline" />
            <Title align={"center"} size={"xl"}>
                Loading error
            </Title>
            <BaseText align={"center"}>There was a problem loading this page.</BaseText>
            {retry && <Button variant="primary" title="Reload page" onPress={retry} size="lg" />}
        </View>
    );
};
